import { useState, useEffect, useLayoutEffect, useRef, CSSProperties } from "react";
import { getOrgOnlineRatio, getProjectOnlineRatio } from "../../../api/dashboard";
import ChartCanvas from './ChartCanvas'
import { EChartsOption } from "echarts";
import { Title, Loading } from "../Layouts";
import { Select } from "antd";
import styles from './OnlineRatioAxis.module.scss';

export default function OnlineRatioAxis(p: { projectId?: any, orgId?: any, style: CSSProperties }) {
    const [data, setData] = useState<OnlineStatisticElement[]>();
    const [options, setOptions] = useState<EChartsOption>();
    const [loading, setLoading] = useState(false);
    const titleRef = useRef<HTMLDivElement>(null);
    const bottomRef = useRef<HTMLDivElement>(null);
    const [hover, setHover] = useState(false);
    const [timeRange, setTimeRange] = useState('DAY');
    const [canvasHeight, setCanvasHeight] = useState((p.style.height as number) - 27.5);
    const [pagination, setPagination] = useState({
        start: 0,
        end: 15
    });
    useEffect(() => {
        if (!data) return;
        const baseOptions: EChartsOption = {
            backgroundColor: 'rgb(9, 53, 99)',
            tooltip: {
                trigger: 'axis'
            },
            grid: {
                top: '10%',
                bottom: '10%',
                left: '10%',
                right: '5%',
            },
            yAxis: {
                type: 'value',
                splitLine: {
                    lineStyle: { type: 'dashed' }
                }
            },
        };
        const { start, end } = pagination;
        // const dataSlice = data?.slice(start, end) || [];
        const dataSlice = data || [];
        const option: EChartsOption = {
            ...baseOptions,
            xAxis: {
                type: 'category',
                data: dataSlice.map(i => i.period),
                axisLabel: {
                    interval: 0,
                    show: false
                },
                axisLine: {
                }
            },
            series: [
                {
                    areaStyle: {
                        opacity: 0.3
                    },
                    lineStyle: {
                        color: 'rgb(4, 137, 194)'
                    },
                    smooth: true,
                    data: dataSlice.map(i => i.deviceCnt === 0 ? '0' : ((i.onlineDeviceCnt / i.deviceCnt) * 100).toFixed(2)),
                    type: 'line'
                },
            ]
        };
        setOptions(option as any);

    }, [data, pagination]);
    useEffect(() => {
        // if (data?.length === 0 || hover) return;
        // const timer = setTimeout(() => {
        //     const { start, end } = pagination;
        //     const isEnd = end >= (data?.length || 0);
        //     setPagination(isEnd ? {
        //         start: 0,
        //         end: 15,
        //     } : {
        //         start: start + 1,
        //         end: end + 1
        //     })
        // }, 1000);
        // return () => {
        //     clearTimeout(timer)
        // }
    }, [pagination, data, hover]);
    useEffect(() => {
        if (!p.orgId && !p.projectId) return;
        setLoading(true);
        (p.orgId ? getOrgOnlineRatio(p.orgId, timeRange) :
            getProjectOnlineRatio(p.projectId, timeRange)
        )
            .then((res) => {
                setData(res.onlineStatistics)
            }).finally(() => {
                setLoading(false)
            })
    }, [p.orgId, timeRange, p.projectId]);
    useLayoutEffect(() => {
        if (titleRef.current) {
            const bottomHeight = bottomRef.current?.clientHeight || 18;
            setCanvasHeight((p.style.height as number) - titleRef.current.clientHeight - bottomHeight)
        }
    }, [p.style.height])
    return <div style={{ ...p.style, background: 'rgb(9, 53, 99)' }} onMouseEnter={() => {
        setHover(true)
    }}
        onMouseLeave={() => {
            setHover(false)
        }}
    >
        <Title ref={titleRef}>
            <div className={styles.title}>
                <span>在线率统计(%)</span>
                <Select showArrow={false} style={{ width: 60, height: '1em' }} options={[
                    { value: 'DAY', label: '一天' },
                    { value: 'WEEK', label: '一周' }
                ]} size='small' value={timeRange} onChange={setTimeRange} />
            </div>
        </Title>
        {
            loading ?
                <div style={{
                    width: p.style.width, height: canvasHeight,
                    background: 'rgb(9, 53, 99)'
                }}>
                    <Loading />
                </div> :
                <ChartCanvas options={options} styles={{
                    width: p.style.width, height: canvasHeight
                }} />
        }
        <div ref={bottomRef} style={{
            display: 'flex', justifyContent: 'space-between',
            alignItems: 'center',
            padding: '0 4px',
            height: (p.style.height as number) * 0.2,
            color: '#fff'
        }}>
            <span>{data?.[0]?.period}</span>
            <span>~</span>
            <span>{data?.[data?.length - 1]?.period}</span>
        </div>

    </div>
}